import Keycloak from "keycloak-js";
import { getInReviewApp } from "../helpers/inReviewApp";

class KeycloakService {
  private static instance: Keycloak.KeycloakInstance | null = null;

  public static async getInstance(): Promise<Keycloak.KeycloakInstance> {
    if (!KeycloakService.instance) {
      const inReview = await getInReviewApp();

      const configs = {
        url: inReview?.keycloak_url ?? process.env.REACT_APP_KEYCLOAK_URL,
        realm: process.env.REACT_APP_KEYCLOAK_REALM,
        clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
      };

      KeycloakService.instance = new Keycloak(configs);
    }

    return KeycloakService.instance;
  }
}

export default KeycloakService;
